module.exports = __webpack_public_path__ + "fa-regular-400.ff9aece3d4cade92f2fd.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-regular-400.ttf
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.ttf
// module chunks = styles